
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCursorActionPointerIcon as ObiCursorActionPointerIconElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cursor-action-pointer-icon.js';
 
 
 

 
 export const ObiCursorActionPointerIcon = createComponent({
   react: React,
   tagName: 'obi-cursor-action-pointer-icon',
   elementClass: ObiCursorActionPointerIconElement,
   events: {
     
   }
  });
 
 